import { K3Extensions } from '@k3/core';
import { Divider, Stack } from '@mui/material';
import { Overview } from './Overview';
import { DeepRequired } from '../../types/DeepRequired';
import { PriceInformation } from './PriceInformation';

export const Sidebar: DeepRequired<K3Extensions>['app']['sidebar']['root'] =
  (Wrapped) => (props) => {
    return (
      <Stack>
        <PriceInformation />
        <Divider />
        {props.group?.key === 'overview' ? (
          <Overview />
        ) : (
          <Wrapped {...props} />
        )}
      </Stack>
    );
  };
